import withQuery from '../hoc/withQuery';
import PreviewCardContainerComponent from '../components/PreviewCardContainer';

const PreviewCardContainer = withQuery(PreviewCardContainerComponent);

export default PreviewCardContainer;
